export default class TagsApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getTags(params, httpConfig) {
    return this.httpGet('tags', params, httpConfig);
  }

  createTag(tag, params, httpConfig) {
    return this.httpPost('tags', tag, params, httpConfig);
  }

  updateTag(tag, params, httpConfig) {
    return this.httpPut(`tags/${tag.id}`, tag, params, httpConfig);
  }

  deleteTag(tagId, params, httpConfig) {
    return this.httpDelete(`tags/${tagId}`, params, httpConfig);
  }

  deleteTags(tags, params, httpConfig) {
    return this.httpPost('tags/bulk', tags, params, httpConfig);
  }
}
